import '../text';
import { defineCustomElement, updateAttribute, NectaryElement, updateBooleanAttribute, getIntegerAttribute, getBooleanAttribute, attrValueToInteger, isAttrTrue, isAttrEqual } from '../utils';
const templateHTML = '<style>:host{display:block}#wrapper{display:flex;align-items:center;height:24px}#bar,#progress{height:8px;border-radius:4px}#progress{background-color:var(--sinch-comp-progress-color-default-background-initial);flex:1;min-width:0}#bar{background-color:var(--sinch-comp-progress-color-default-bar-initial);width:0}#text{display:none;width:46px;--sinch-global-color-text:var(--sinch-comp-progress-color-default-text-initial)}:host([detailed]) #text{display:block}</style><div id="wrapper"><sinch-text id="text" type="m"></sinch-text><div id="progress"><div id="bar"></div></div></div>';
const template = document.createElement('template');
template.innerHTML = templateHTML;
defineCustomElement('sinch-progress', class extends NectaryElement {
  #$bar;
  #$text;
  constructor() {
    super();
    const shadowRoot = this.attachShadow();
    shadowRoot.appendChild(template.content.cloneNode(true));
    this.#$bar = shadowRoot.querySelector('#bar');
    this.#$text = shadowRoot.querySelector('#text');
  }
  connectedCallback() {
    this.setAttribute('role', 'progressbar');
  }
  static get observedAttributes() {
    return ['value', 'detailed'];
  }
  attributeChangedCallback(name, oldVal, newVal) {
    switch (name) {
      case 'value':
        {
          const int = attrValueToInteger(newVal, {
            min: 0,
            max: 100
          });
          const intCss = int === null ? '0%' : `${int}%`;
          this.#$bar.style.width = intCss;
          this.#$text.textContent = intCss;
          this.setAttribute('valuenow', int !== null ? String(int) : '0');
          break;
        }
      case 'detailed':
        {
          if (isAttrEqual(oldVal, newVal)) {
            break;
          }
          updateBooleanAttribute(this, name, isAttrTrue(newVal));
          break;
        }
    }
  }
  get value() {
    return getIntegerAttribute(this, 'value', 0);
  }
  set value(value) {
    updateAttribute(this, 'value', value);
  }
  get detailed() {
    return getBooleanAttribute(this, 'detailed');
  }
  set detailed(isDetailed) {
    updateBooleanAttribute(this, 'detailed', isDetailed);
  }
});